import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Facebook(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M18,2 C26.837,2 34,9.163 34,18 C34,25.8712464 28.3173653,32.4138576 20.8314199,33.7494667 L20.5,33.805 L20.5,22.625 L24.228,22.625 L24.938,18 L20.5,18 L20.5,14.999 C20.5,13.733 21.12,12.5 23.107,12.5 L25.125,12.5 L25.125,8.563 L24.6251364,8.48689713 L24.6251364,8.48689713 L23.9083947,8.39674127 L23.9083947,8.39674127 L23.560296,8.35987673 L23.560296,8.35987673 L22.9907057,8.30969998 L22.9907057,8.30969998 L22.587912,8.28245263 L22.587912,8.28245263 L22.1735138,8.26240071 C22.1038065,8.25976464 22.0338604,8.25750811 21.9637976,8.25567098 L21.543,8.25 C17.889,8.25 15.5,10.465 15.5,14.475 L15.5,18 L11.437,18 L11.437,22.625 L15.5,22.625 L15.5,33.805 L15.1685801,33.750381 C7.68263474,32.4128578 2,25.8702609 2,18 C2,9.163 9.163,2 18,2 Z"
        fillRule="nonzero"
      ></path>
    </IconSvg>
  );
}
